import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
/** We have to wrap this badge with a tooltip outside of da-ds since tooltips still live in da-shared-react */
var PromoBadgeWithTooltip = function (_a) {
    var isLocked = _a.isLocked, rest = __rest(_a, ["isLocked"]);
    var t = useTranslation().t;
    return (React.createElement(SimpleTooltip, { placement: "bottom", text: t(isLocked ? 'promoBadge.locked.tooltip' : 'promoBadge.unlocked.tooltip') },
        React.createElement(PromoBadge, __assign({ isLocked: isLocked }, rest))));
};
PromoBadgeWithTooltip.displayName = 'PromoBadgeWithTooltip';
export default PromoBadgeWithTooltip;
//# sourceMappingURL=PromoBadgeWithTooltip.js.map